export const EMPTY_PLAYER = {lastname : '...', firstname : '...'}

export const COACH_PLAYER = (team) => ({lastname : 'l\'entraineur de '+team.name})